import { Box, Button, Card, CardContent, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { AutocompleteComponent } from 'src/features/filters/Autocomplete'
import { Option } from 'src/features/autocomplete/types'
import { autocompleteEndpoint, getLeadFilterEndpoint } from 'src/configs/endpoints';
import { client } from 'src/utils/axios-client';
import Chip from '@mui/material/Chip'
import { v4 as uuidv4 } from 'uuid';
import SprintStore from 'src/stores/SprintStore';
import { Filter, FilterCategory, FilterType } from '../FilterTypes';
import CustomDatePicker from '../../common/CustomDatePicker';
import PerfectScrollbar from 'react-perfect-scrollbar'
import FallbackSpinner from '../../../materio/@core/components/spinner';
import LoadingSpinner from '../../../components/LoadingSpinner';


type Props = {
    filter: Filter,
    onFiltersChanged: (updatedDilter: Filter) => void,

}

const Filters2 = ({ onFiltersChanged, filter }: Props) => {
    /*const [myFilters, setMyFilters] = useState([] as Option[]);*/
    const [filters, setFilters] = useState([] as FilterCategory[])
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    /*const leadFilters = SprintStore.useState(s => s.leadFilters);*/
    /*const [selectedFilter, setSelectedFilter] = useState('')*/
    //const [saveOpen, setSaveOpen] = useState(false);
    //const [saveAsOpen, setSaveAsOpen] = useState(false);
    //const [filterNameError, setFilterNameError] = useState(false);
    //const [filterName, setFilterName] = useState('')

    useEffect(() => {
        setLoading(true);
        const search = async () => {
            const response = await client.post(autocompleteEndpoint, {
                optionTypes: ['COUNTRY', 'ACCOUNT_COUNTRY', 'REGION', 'ACCOUNT_REGION', 'INDUSTRY', 'ACCOUNT_INDUSTRY',
                    'REVENUE', 'ACCOUNT', 'LEVEL', 'TIMEZONES', 'EMPLOYEESIZE', 'FUNCTION', 'ACTIVITY_DATE', "LEAD_OTHER",
                    "STAGE", "CUSTOMERS", "SPRINT", "PLAYBOOKS", "PLAYBOOKCADENCES", "PLAYBOOKCADENCESTEPS", "OWNER", "ACTIVITY_TYPES",
                    "ACCOUNT_KEYWORDS"]
            })

            setFilters(response.data);
            setLoading(false);
            //await loadMyFilters();
            /*leadFilters && leadFilters.id && loadFilter(leadFilters.id)*/
        }

        search();
    }, [])

    //const loadMyFilters = async () => {
    //    const response3 = await client.get(getUserLeadFiltersEndpoint);

    //    setMyFilters(response3.data);
    //}

    const onStartDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.startDate = value;
        onFiltersChanged(updatedFilter);
    }

    const onEndDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.endDate = value;
        onFiltersChanged(updatedFilter);
    }

    const toggleOption = (selectedCat: FilterCategory, selectedOpt: Option) => {
        const updatedFilter = _.cloneDeep(filter);
        //const updatedOptions = _.cloneDeep(options);

        const optIndex = updatedFilter.options.findIndex(op => op.value == selectedOpt.value && op.optionType === selectedCat.optionType);

        if (optIndex >= 0) {
            const item = updatedFilter.options[optIndex];

            if (!item.inclusive) {
                updatedFilter.options.splice(optIndex, 1);
            } else {
                item.inclusive = false;
            }
        }
        else {
            updatedFilter.options.push({
                id: uuidv4(),
                parentId: '',
                value: selectedOpt.value,
                name: selectedOpt.name,
                optionType: selectedCat.optionType,
                selected: true,
                inclusive: true
            });
        }

        onFiltersChanged(updatedFilter);
    }

    const onActivityDateChange = (value: string) => {
        const updatedFilter = _.cloneDeep(filter);

        updatedFilter.activityDate = value;

        onFiltersChanged(updatedFilter);
    }

    const renderFilter = (cat: FilterCategory) => {
        const filtersForCat = filter.options.filter(opt => opt.optionType == cat.optionType);


        if (filtersForCat.length === 0) return null;

        return <Card sx={{ padding: 0, width: '100%' }}>
            <CardContent>
                <Typography component='p' variant='overline' sx={{ lineHeight: 1.25, color: 'text.disabled', mb: 2.5 }}>
                    {cat.category}
                </Typography>

                <Grid container>
                    <Grid item xs={12}>
                        {filtersForCat.map(opt => <Chip color={opt.inclusive ? 'success' : 'error'} label={opt.name} onClick={() => toggleOption(cat, opt)} onDelete={() => toggleOption(cat, opt)} />)}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', minHeight: 0, gap: 4, rowGap: 8, flexGrow: 2, width: '100%' }}>
            {loading && <Box sx={{ flexBasis: 0, flexGrow: 1, width: '100%' }}><LoadingSpinner text="Loading Filter Options" /></Box>}
            {!loading && <Box sx={{ flexBasis: 0, flexGrow: 1, minWidth: 400 }}>
                <AutocompleteComponent filters={filters} toggleOption={toggleOption} filter={filter} onFiltersChanged={onFiltersChanged} />
            </Box>}
            {!loading && <Box sx={{ display: 'flex', flexBasis: 0, flexGrow: 2, minHeight: 0, height: '100%', maxHeight: '100%', overflowY: 'auto', width: '100%'}}>
                <PerfectScrollbar options={{ wheelPropagation: false }} id='filters-card' className='ps-show-always' style={{ width: '100%' }}>
                    <Box sx={{ maxHeight: '100%', minHeight: '0', height: '100%' }}>
                        {filters && filters.map(cat => renderFilter(cat))}
                        {filter.options.some(cat => cat.optionType === cat.optionType) ? null : <div>No filters selected.</div>}
                    </Box>
                </PerfectScrollbar>
            </Box>}
        </Box>
    )
}

export { Filters2 }
export default Filters2;